/**
 * Couleurs des blocs de la Timeline de regulation par statut d'intervention.
 * Partage entre RegulationPage.tsx (tableau de bord) et
 * RegulationTimelinePage.tsx (vue pleine largeur, timeline continue).
 */
export const STATUT_TIMELINE_COLORS: Record<string, string> = {
  en_attente: 'bg-blue-200 border-blue-400',
  affectee: 'bg-orange-200 border-orange-400',
  en_deplacement: 'bg-violet-200 border-violet-400',
  en_cours: 'bg-red-200 border-red-400',
  cloturee: 'bg-lime-200 border-lime-400',
  validee: 'bg-green-200 border-green-400',
  annulee: 'bg-gray-200 border-gray-400',
};
